import { USER_PHONE_OR_EMAIL } from '../types/chatBot';

export const setChatBotPhoneOrEmail = (payload: any) => ({
  type: USER_PHONE_OR_EMAIL,
  payload,
});
